import { FC, useEffect, useState } from "react";
import Menu from "./Menu";
import Header from "./Header";
import styles from "./Document.module.sass";
import { LocalizationMap, ProgressBar, Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import ru_RU from "@react-pdf-viewer/locales/lib/ru_RU.json";
import { baseURL } from "libs/axios";
import { useParams } from "react-router-dom";
import {objectsKiiAPI} from "../../../../../libs/apiClient/ObjectsKii";

const Document: FC = () => {
	const [url, setUrl] = useState<any>();
	const [docName, setDocName] = useState<string>("");

	const { documentId } = useParams();

	useEffect(() => {
		if (documentId) {
			const fetchUrl = async () => {
				setUrl((await objectsKiiAPI.docsLinkDetail(+documentId).then(({data})=>data)));
			};

			fetchUrl();
		}
	}, [documentId]);

	useEffect(() => {
		if (url) {
			setDocName(url.replace(/^\/(.+)\/(.+)\..+/g, "$2.docx"));
		}
	}, [url]);

	return (
		<div className={styles.wrapper}>
			<Header docName={docName} />
			<div className={styles.main}>
				<Menu />
				<div data-comment-false={true} className={styles.docViewer}>
					<Worker workerUrl="/static/js/pdf.worker.min.js">
						<Viewer
							fileUrl={`${baseURL}${url ? url : "/"}`}
							httpHeaders={{
								Authorization: `Bearer ${localStorage.getItem("token")}`,
							}}
							renderLoader={(percentages: number) => (
								<div style={{ width: "240px" }}>
									<ProgressBar progress={Math.round(percentages)} />
								</div>
							)}
							renderError={() => <div></div>}
							localization={ru_RU as unknown as LocalizationMap}
						/>
					</Worker>
				</div>
			</div>
		</div>
	);
};

export default Document;
